import { NgModule } from "@angular/core";
import { ReportViewerModule } from "ngx-ssrs-reportviewer";
import { CommonModule } from "@angular/common";
import { FormatoPdfFichaTecnicaComponent } from "./components/formato-pdf-ficha-tecnica/formato-pdf-ficha-tecnica.component";
import { GeneracionObrasComponent } from "./components/generacion-obras/generacion-obras.component";
import { GeneradorFichaTecnicaComponent } from "./components/generador-ficha-tecnica/generador-ficha-tecnica.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { AppRoutingModule } from "src/app/core/app-routing.module";
import { TooltipModule } from "primeng/tooltip";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EdicionFichaTecnicaComponent } from "./components/edicion-ficha-tecnica/edicion-ficha-tecnica.component";
import { ModalFichaTecnicaComponent } from "./components/modal-ficha-tecnica/modal-ficha-tecnica.component";
import { AgmCoreModule } from "@agm/core";
import { GeneradorIncidenciaObraComponent } from "./components/generador-incidencia-obra/generador-incidencia-obra.component";
import { ModalIncidenciaObraComponent } from "./components/modal-incidencia-obra/modal-incidencia-obra.component";
import { FormatoPdfIncidenciaObraComponent } from "./components/formato-pdf-incidencia-obra/formato-pdf-incidencia-obra.component";
import { ModalNotaInformativaComponent } from "./components/modal-nota-informativa/modal-nota-informativa.component";
import { FormatoPdfNotaInformativaComponent } from "./components/formato-pdf-nota-informativa/formato-pdf-nota-informativa.component";
import { EdicionIncidenciaObraComponent } from "./components/edicion-incidencia-obra/edicion-incidencia-obra.component";
import { AdmonTramoLicitacionComponent } from "./components/admon-tramo-licitacion/admon-tramo-licitacion.component";
import { PanelModule } from "primeng/panel";
import { GeneradorFichaPlaneacionComponent } from "./components/generador-ficha-planeacion/generador-ficha-planeacion.component";
import { EdicionFichaPlaneacionComponent } from "./components/edicion-ficha-planeacion/edicion-ficha-planeacion.component";
import { ModalFichaElementosComponent } from "./components/modal-ficha-elementos/modal-ficha-elementos.component";
import { FormatoPdfFichaElementosComponent } from "./components/formato-pdf-ficha-elementos/formato-pdf-ficha-elementos.component";
import { ConsultarObrasComponent } from "./components/consultar-obras/consultar-obras.component";
import { NgProgressModule } from "@ngx-progressbar/core";
import { NgProgressHttpModule } from "@ngx-progressbar/http";
import { HttpClientModule } from "@angular/common/http";
import { CheckboxModule } from "primeng/checkbox";
import { LarguilloComponent } from "./components/larguillo/larguillo.component";
import { MultiSelectModule } from "primeng/multiselect";
import { SharedModule } from "src/app/shared/shared.module";
import { BusquedasModule } from "../busquedas/busquedas.module";
import { ConsultarHistoricoObrasComponent } from "./components/consultar-historico-obras/consultar-historico-obras.component";
import { ModalFichaTecnicaHistoricoComponent } from "./components/modal-ficha-tecnica-historico/modal-ficha-tecnica-historico.component";
import { FormatoPdfFichaTecnicaHistoricoComponent } from "./components/formato-pdf-ficha-tecnica-historico/formato-pdf-ficha-tecnica-historico.component";
import { BuscadorArchivosObrasComponent } from "./components/buscador-archivos-obras/buscador-archivos-obras.component";
import { ModalPDFFichaTecnicaComponent } from "./components/modal-pdf-ficha-tecnica/modal-pdf-ficha-tecnica.component";
import { PdfViewerModule } from "ng2-pdf-viewer";

@NgModule({
  declarations: [
    FormatoPdfFichaTecnicaComponent,
    GeneracionObrasComponent,
    GeneradorFichaTecnicaComponent,
    EdicionFichaTecnicaComponent,
    ModalFichaTecnicaComponent,
    GeneradorIncidenciaObraComponent,
    ModalIncidenciaObraComponent,
    FormatoPdfIncidenciaObraComponent,
    ModalNotaInformativaComponent,
    FormatoPdfNotaInformativaComponent,
    EdicionIncidenciaObraComponent,
    AdmonTramoLicitacionComponent,
    ConsultarObrasComponent,
    GeneradorFichaPlaneacionComponent,
    EdicionFichaPlaneacionComponent,
    ModalFichaElementosComponent,
    FormatoPdfFichaElementosComponent,
    LarguilloComponent,
    ConsultarHistoricoObrasComponent,
    ModalFichaTecnicaHistoricoComponent,
    FormatoPdfFichaTecnicaHistoricoComponent,
    BuscadorArchivosObrasComponent,
    ModalPDFFichaTecnicaComponent,
  ],
  imports: [
    CommonModule,
    NgProgressModule,
    NgProgressHttpModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    AgmCoreModule,
    ReactiveFormsModule,
    CalendarModule,
    TableModule,
    DropdownModule,
    ScrollingModule,
    NgbModule,
    TooltipModule,
    PanelModule,
    CheckboxModule,
    MultiSelectModule,
    SharedModule,
    BusquedasModule,
    PdfViewerModule,
    ReportViewerModule,
  ],
  exports: [
    FormatoPdfFichaTecnicaComponent,
    GeneracionObrasComponent,
    GeneradorFichaTecnicaComponent,
    EdicionFichaTecnicaComponent,
    ModalFichaTecnicaComponent,
    ConsultarObrasComponent,
    ModalNotaInformativaComponent,
    ModalFichaElementosComponent,
    ModalPDFFichaTecnicaComponent,
  ],
})
export class ObrasModule {}
